import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  faLock,
  faSortDown,
  faSortUp,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit, OnChanges {
  faSortDown = faSortDown;
  faSortUp = faSortUp;
  public faLock = faLock;

  @Input() public title?: string;
  @Input() public placeholder: string = '';
  @Input() public inputValue: string = '';
  @Input() public rightText: string = '';
  @Input() public searchable: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public readonly: boolean = false;
  @Input() public opened: boolean = false;
  @Input() public permanentlyOpened: boolean = false;
  @Input() public horizontal: boolean = false;
  @Input() public showLock: boolean = false;
  @Input() public showArrow: boolean = true;
  @Input() public info?: string;
  @Input() public showInfo?: boolean = true;

  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() openDropdownAction: EventEmitter<any> = new EventEmitter();
  @Output() onDropdownClick: EventEmitter<any> = new EventEmitter();

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('container') container: ElementRef<HTMLElement>;

  public dropdownOpen = false;
  public showDropdownOnLeft = false;

  private _timeout: number;

  public ngOnInit() {
    this.dropdownOpen = this.opened;
    if (this.permanentlyOpened) {
      this.dropdownOpen = true;
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.dropdownOpen = changes?.opened?.currentValue || false;
  }

  public onType(event: any) {
    this.inputValue =
      (event && event.target && event.target.value).trim() || '';
    this.onSearch();
  }

  public onSearch() {
    window.clearTimeout(this._timeout);

    this._timeout = window.setTimeout(() => {
      this.search.emit(this.inputValue);
    }, 400);
  }

  public closeWhenClickedOutside(event: Event): void {
    if (this.permanentlyOpened) {
      return;
    }
    this.dropdownOpen = false;
    this.toggle.emit(this.dropdownOpen);
  }

  public clickDropdown() {
    if (this.showLock || this.disabled) {
      return;
    }
    if (this.horizontal) {
      this.onDropdownClick.emit(this.title);
      return;
    }
    this.toggleDropdown();
  }

  public toggleDropdown() {
    if (this.permanentlyOpened) {
      return;
    }
    if (this.disabled) {
      return;
    }
    this.dropdownOpen = !this.dropdownOpen;
    if (this.dropdownOpen) {
      !this.horizontal && this.input.nativeElement.focus();
      this.openDropdownAction.emit();
    } else {
      !this.horizontal && this.input.nativeElement.blur();
    }
    this.toggle.emit(this.dropdownOpen);
  }

  public toggleDropdownWithParam(isOpen: boolean) {
    if (this.horizontal) {
      this.showDropdownOnLeft = !this.isElementInViewport(this.container);
    }
    this.dropdownOpen = isOpen;
  }

  private isElementInViewport(el: ElementRef<HTMLElement>) {
    var rect = el.nativeElement.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right + rect.width <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  public closeDropdown() {
    this.dropdownOpen = false;
    this.toggle.emit(this.dropdownOpen);
  }

  public focusInput() {
    this.input.nativeElement.focus();
  }
}
